
import ComplexResponsiveComponent from "../complex-responsive-component";

export default class extends ComplexResponsiveComponent {
  static jsClass = 'TableContainer';
}